/**
 * Do not change order. Or handle ordering of solutions on hompeage etc.
 */
export enum SolutionGroup {
	ByDesignation = "ByDesignation",
	ByTechnology = "ByTechnology",
	ByIndustry = "ByIndustry",
	ByProduct = "ByProduct",
}
